export enum FilterDialogItemType {
    Unknown = 0,
    Text = 1,
    Filter = 2
}
